import React from 'react';
import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuoteLeft } from '@fortawesome/free-solid-svg-icons';

const Testimonials = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const testimonials = [
    {
      quote: "Derek excels in seamless interaction design—detail-oriented, user-focused, and unafraid to challenge the status quo to create user-centric, frictionless experiences.",
      name: "Cyril Jones",
      title: "Senior Director of Software Engineering & Product, Acres & AcreTrader"
    },
    {
      quote: "Derek's design expertise transformed our vision into reality. His meticulous attention to detail and user-centered approach resulted in a product that our users absolutely love.",
      name: "April Roy",
      title: "Founder & CEO, femPAQ, Inc."
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % testimonials.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [testimonials.length]);

  return (
    <div id="testimonials" className="w-full bg-dj-light py-16 md:py-24 px-4 md:px-20">
      <div className="w-full max-w-6xl mx-auto">
        {/* Header with Icon */}
        <div className="mb-12 md:mb-16">
          <div className="flex items-center gap-3 mb-4">
            <p className="text-secondary font-bold text-sm md:text-base tracking-wide uppercase mb-0">Testimonials</p>
          </div>
          <h2 className="text-5xl md:text-6xl font-bold text-dj-dark">
            What People Say
          </h2>
        </div>

        {/* Testimonial Carousel */}
        <div className="grid grid-cols-1 lg:grid-cols-1 gap-12">
          <div className="relative overflow-hidden">
            {/* Testimonial Card */}
            <div className="bg-white rounded-xl shadow-lg p-8 md:p-14 border-l-4 border-primary hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 animate-slide-in">
              <FontAwesomeIcon icon={faQuoteLeft} className="text-primary text-5xl mb-8 opacity-30" />
              <p className="text-lg md:text-xl text-gray-700 leading-relaxed mb-6 md:mb-4 font-medium h-auto md:h-28">
                {testimonials[currentSlide].quote}
              </p>
              <div className="border-t border-gray-200 py-5 md:py-3">
                <p className="font-bold text-dj-dark text-lg">{testimonials[currentSlide].name}</p>
                <p className="text-secondary font-semibold text-sm">{testimonials[currentSlide].title}</p>
              </div>
            </div>

            {/* Navigation Buttons */}
            <div className="flex justify-center items-center mt-8">
              {/* Indicators */}
              <div className="flex gap-2">
                {testimonials.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentSlide(index)}
                    className={`h-2 w-2 rounded-full transition-colors ${
                      index === currentSlide ? 'bg-primary' : 'bg-gray-400'
                    }`}
                    aria-label={`Go to testimonial ${index + 1}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
